// extracted by mini-css-extract-plugin
module.exports = {"header":"kX","blackNav":"kY","childrenFrame":"kZ"};